import React, { useEffect } from "react";
import {
  GET_HOST_WITH_ALERTS,
  SET_NETSPACE_LOADER,
  SET_SELECTED_GROUP,
  SET_SELECTED_LABEL,
  SET_SITEMAP_EXPAND_ACCORDION,
  desiredOrderAlerts,
  desiredOrderCVESeverity,
  sensitivityMap,
} from "./NetSpaceConstant";
import { useSelector, useDispatch } from "react-redux";
import Page_Loader from "../../assets/vizr_images/page_loader.gif";
import { Grid, Box } from "material-ui-core";
import CardContent from "@material-ui/core/CardContent";
import { StyledCardHeader, formatNumberUS, sensitivityColor } from "./NetSpaceUtils";
import RadialChart from "./RadialChart";
import { CustomCard } from "./NetSpaceCommonComp";

function HostWithAlerts() {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch({
      type: GET_HOST_WITH_ALERTS,
    });
  }, [dispatch]);

  const hostWithAlert = useSelector(
    (state) => state.NetspaceReducer.hostWithAlert,
  );


  const loader = useSelector(
    (state) => state.NetspaceReducer.componentLoader[GET_HOST_WITH_ALERTS],
  );
  const reduxSelectedLabel = useSelector(
        (state) => state.NetspaceReducer?.selectedLabel,
      );

  const totalAlerts = hostWithAlert
    ? Object.values(hostWithAlert).reduce((acc, curr) => acc + curr, 0)
    : 0;

  const renderContent = () => {
    if (!hostWithAlert) return null;

    let renderEachAlert = [];
    let radialData = [];

    desiredOrderCVESeverity.forEach((alert) => {
      if (hostWithAlert[alert] > 0) {
        // Override CRITICAL color
        const color =
          alert === "CRITICAL" ? "#e22d1b" : sensitivityColor(alert);

        renderEachAlert.push(
          <Grid item xs={12} key={alert}>
            <div
              className={`clickable-label ${alert}`}
              style={{ color }}
              onClick={() => {
                const isSameLabel = reduxSelectedLabel === sensitivityMap[alert];
                dispatch({ type: SET_NETSPACE_LOADER, payload: true })

                dispatch({
                  type: SET_SITEMAP_EXPAND_ACCORDION,
                  payload: {},
                });

                if (isSameLabel) {
                  dispatch({
                    type: SET_SELECTED_LABEL,
                    payload: null,
                  });

                  dispatch({
                    type: SET_SITEMAP_EXPAND_ACCORDION,
                    payload: {},
                  });

                  return;
                }
                dispatch({
                  type: SET_SELECTED_LABEL,
                  payload: sensitivityMap[alert],
                });
                dispatch({
                  type: SET_SELECTED_GROUP,
                  payload: {
                    group: "ALERTS",
                    place: "non-widget",
                  },
                });
              }}
            >
              {formatNumberUS(hostWithAlert[alert])} {sensitivityMap[alert]}
            </div>
          </Grid>,
        );

        radialData.push({
          name: alert,
          value: hostWithAlert[alert],
          fill: color,
        });
      }
    });

    // optional center filler (depends on your RadialChart design)
    radialData.push({ name: "", value: formatNumberUS(totalAlerts), fill: "#ffffff" });

    return (
      <Grid container direction="row" spacing={2}>
        <div className="netspace-common-container-class">
          <div className="netspace-value-container">{renderEachAlert}</div>
        </div>

        <Grid item xs={4}>
          <Box sx={{ width: 110, height: 100, marginLeft: 5 }}>
            <div className="radial-chart-container">
              <RadialChart radialData={radialData} totalAlerts={totalAlerts} />
            </div>
          </Box>
        </Grid>
      </Grid>
    );
  };

  return (
    <Grid item size={1}>
      <CustomCard color={"white"}>
        {/* Updated title */}
        <div className="common-widget-title">
          <StyledCardHeader
            title={
              <span>
                Host with Alerts: {formatNumberUS(totalAlerts)}
              </span>
            }
          />
        </div>

        <CardContent className="card-content">
          {loader ? (
            <img src={Page_Loader} alt="loading" className="loader-img" />
          ) : (
            renderContent()
          )}
        </CardContent>
      </CustomCard>
    </Grid>
  );
}

export default HostWithAlerts;
